var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoappointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "666.95 150.27 657.38 196.62 651.22 190.61 640.74 198.09 632.73 188.14 614.77 201.2 599.42 175.53 582.3 185.56 575.51 176.2 553.77 188.45 547.23 174.44 562.47 100.63 644.17 117.5 666.95 150.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.17 117.5 666.95 150.27 638.61 144.42 644.17 117.5",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "655.34 205.88 641.31 273.88 531.26 251.16 545.19 183.71 551.73 197.71 573.48 185.46 580.26 194.82 597.39 184.8 612.73 210.47 630.7 197.41 638.7 207.35 649.19 199.88 655.34 205.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.83 197.91 385.68 204.85 376.77 60.89 460.05 55.73 490.62 81.38 497.83 197.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.05 55.73 490.62 81.38 461.74 83.17 460.05 55.73",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,152.6l-.44-3.25c-1.13-6.73.71-14.26,6.56-22.13,5.28-7,8.14-12,7.82-17.68-.36-6.4-4.61-10.44-12.52-10.12a22.31,22.31,0,0,0-12.45,4.6l-3.45-7.73c4-3.25,11-5.65,17.65-6,14.43-.8,21.45,7.74,22,17.27.48,8.53-3.94,14.94-9.56,22.43-5.16,6.83-6.85,12.46-6.12,18.83l.31,3.26Zm-1.78,17.71c-.26-4.64,2.69-8.08,7.08-8.32s7.59,2.84,7.85,7.49c.24,4.39-2.45,7.93-7.09,8.19C430.63,177.92,427.43,174.7,427.18,170.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,128.11,137.2,123l-1.57,3.45a3,3,0,0,1-2.57,1.72,14.48,14.48,0,0,0-1.85.18,3,3,0,0,1-2.85-1.18l-2.21-3.09-10.07,7.22,2.21,3.09a3,3,0,0,1,.2,3.07,18.29,18.29,0,0,0-.77,1.69,3,3,0,0,1-2.45,1.89l-3.77.37,1.21,12.33,3.79-.38a3,3,0,0,1,2.77,1.38c.16.26.33.51.51.76s.36.49.55.73a2.94,2.94,0,0,1,.42,3.05l-1.58,3.48,11.29,5.12,1.57-3.47a3,3,0,0,1,2.58-1.71,16.19,16.19,0,0,0,1.83-.18,3,3,0,0,1,2.85,1.18l2.21,3.09,10.08-7.22-2.21-3.09a2.91,2.91,0,0,1-.2-3.07,17.94,17.94,0,0,0,.75-1.68,2.94,2.94,0,0,1,2.45-1.89l3.79-.38-1.22-12.33-3.79.37a2.94,2.94,0,0,1-2.75-1.37c-.17-.26-.34-.51-.52-.76s-.36-.5-.55-.73a3,3,0,0,1-.42-3.07Zm-6.4,11.41a10.15,10.15,0,1,1-14.16-2.34A10.15,10.15,0,0,1,142.08,139.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.38,291.71l-7.52,4.34,1.33,2.3a2,2,0,0,1-.07,2.17c-.23.36-.45.73-.65,1.12a2,2,0,0,1-1.83,1.14H647v8.69h2.66a2,2,0,0,1,1.83,1.14c.2.39.42.76.65,1.12a2,2,0,0,1,.07,2.17l-1.33,2.3,7.52,4.34,1.34-2.31a2.05,2.05,0,0,1,1.91-1h1.28a2.06,2.06,0,0,1,1.91,1l1.34,2.32,7.51-4.34-1.33-2.31a2.05,2.05,0,0,1,.08-2.16c.23-.36.45-.74.65-1.12a2,2,0,0,1,1.83-1.14h2.66v-8.69H674.9a2,2,0,0,1-1.83-1.14c-.2-.38-.42-.76-.65-1.12a2.05,2.05,0,0,1-.08-2.16l1.33-2.31-7.51-4.34L664.82,294a2.05,2.05,0,0,1-1.91,1l-.64,0-.64,0a2.08,2.08,0,0,1-1.92-1Zm3.89,8.3a7.12,7.12,0,1,1-7.11,7.11A7.11,7.11,0,0,1,662.27,300Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,91.16l-6.89,5.28L166,98.55a2,2,0,0,1,.21,2.15,10.47,10.47,0,0,0-.5,1.2,2.05,2.05,0,0,1-1.67,1.37l-2.64.34,1.12,8.61,2.64-.34a2.06,2.06,0,0,1,2,.9,11.14,11.14,0,0,0,.78,1,2,2,0,0,1,.36,2.13l-1,2.46,8,3.33,1-2.46a2.05,2.05,0,0,1,1.77-1.25l.64-.07.63-.1a2.06,2.06,0,0,1,2,.75l1.63,2.13,6.89-5.28-1.61-2.11a2.06,2.06,0,0,1-.21-2.16,11.12,11.12,0,0,0,.5-1.19,2.05,2.05,0,0,1,1.67-1.37l2.64-.34-1.12-8.61-2.64.34a2.06,2.06,0,0,1-2-.89c-.25-.36-.51-.7-.79-1A2.07,2.07,0,0,1,186,96l1-2.46-8-3.33-1,2.46a2.07,2.07,0,0,1-1.77,1.25l-.64.06L175,94a2.06,2.06,0,0,1-2-.75Zm4.93,7.73a7.11,7.11,0,1,1-6.14,8A7.11,7.11,0,0,1,176.23,98.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82,316.78a275.64,275.64,0,0,0-.4-29,370.79,370.79,0,0,0-9.09-59.16c-2.54-10.94-5.66-21.7-8.92-32.45-.1-.33-.62-.24-.53.1,10.07,37.9,18.33,77,17.76,116.4-.16,11-1.44,21.85-2.48,32.81,0,.29.45.41.52.11C118.75,336.18,119.43,326.36,119.82,316.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,196.24S85.64,234.94,89.05,244s10.45,11,10.45,11-9.33,13.32-2.81,25.81,21,11.9,22,26.06C118.66,306.94,119.46,247.73,100.88,196.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,282.49a.28.28,0,0,0,0-.2,354.31,354.31,0,0,0-14.78-77.85c0-.07-.15-.05-.13,0q4.53,17,8,34.14a16.87,16.87,0,0,0-7.28-4.06s-.08.06,0,.08a19.35,19.35,0,0,1,7.52,5c.44,2.25.88,4.49,1.29,6.74-3.41-3.81-8.13-5.7-12.86-7.5a.06.06,0,0,0,0,.11c4.93,2,9.83,4.58,13.17,8.83q1.74,9.63,3.06,19.33a18.43,18.43,0,0,0-9.09-5.21c-.11,0-.17.13-.06.16A19.16,19.16,0,0,1,115,268l.06,0q.45,3.4.86,6.83a23.37,23.37,0,0,0-6.37-3.84c-.06,0-.1.07,0,.09a21.89,21.89,0,0,1,6.39,4.23s.05,0,.08,0c.25,2.17.5,4.34.72,6.51a31,31,0,0,0-12.93-9.24.08.08,0,0,0,0,.16,33.68,33.68,0,0,1,12.74,9.81.3.3,0,0,0,.32.1c.33,3.33.63,6.66.87,10,0,.05.08.05.08,0Q117.43,287.62,117,282.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,230.71a19.09,19.09,0,0,0-9.16-2.86.06.06,0,0,0,0,.12,36.16,36.16,0,0,1,9.06,3C104.77,231,104.86,230.79,104.75,230.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,271.68a19.06,19.06,0,0,0-6.88-2.35c-.08,0-.09.11,0,.13a26.05,26.05,0,0,1,6.8,2.38C106.61,271.89,106.69,271.73,106.6,271.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,244.67a103.7,103.7,0,0,0-17.65,15.42,63.19,63.19,0,0,0-12.37,21,156.93,156.93,0,0,0-9.22,50.2,122.32,122.32,0,0,0,2.71,28.23.27.27,0,0,0,.53-.1,158.6,158.6,0,0,1,.28-49.35c2.62-16,6.73-33.42,16.91-46.43,5.54-7.09,12.45-12.66,19.28-18.42C160.73,244.9,160.27,244.41,159.9,244.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,319.75a95,95,0,0,1,12.86-16.44c7.63-7.63,14.05-13.05,15.05-18.09s-7.64-8.76-7.64-8.76,10.55,1.9,13.44-2.53,4.28-30.09,4.28-30.09-19.2,13.71-28.15,32.93S122.9,319.75,122.9,319.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25,250.42c-8.08,7.93-16.21,16.39-21,26.82A102.83,102.83,0,0,0,129,288.29v0c-.24.76-.49,1.52-.72,2.28a.19.19,0,0,0,0,.12,218.27,218.27,0,0,0-5.46,23.71c0,.05.07.07.08,0,.83-4,1.74-8,2.76-12.07a.27.27,0,0,0,.12,0,17.14,17.14,0,0,1,5-1.28c.11,0,.1-.21,0-.2a18.78,18.78,0,0,0-5,.91c.93-3.63,1.94-7.26,3.08-10.83a53.32,53.32,0,0,1,11.39-1.49,0,0,0,0,0,0-.06,43,43,0,0,0-11.2.95c.2-.61.41-1.22.61-1.83a59.12,59.12,0,0,1,7.58-1.29s0-.08,0-.08a37,37,0,0,0-7.42.9c1-3.09,2.17-6.14,3.42-9.1a55,55,0,0,1,3.63-7,45.52,45.52,0,0,1,6.15-1.1s0-.1,0-.1a16.67,16.67,0,0,0-5.75.57c1-1.63,2.07-3.23,3.21-4.78h0c4.31-.95,8.67-1.84,13.08-1a.07.07,0,0,0,0-.13c-4.19-1.11-8.35-.47-12.52.35.45-.6.92-1.2,1.39-1.79a28.43,28.43,0,0,1,8-1.27,0,0,0,0,0,0-.09,21.09,21.09,0,0,0-7.5.67c3.56-4.42,7.49-8.58,11.38-12.69C154.58,250.34,154.44,250.23,154.25,250.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,267.91a16.84,16.84,0,0,0-3.82-.13c-.15,0-.14.26,0,.27,1.26,0,2.53-.06,3.79,0A.08.08,0,0,0,154,267.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,292.8a17.2,17.2,0,0,0-5.92,1.18s0,.1,0,.09c2-.47,3.93-.66,5.91-1A.15.15,0,0,0,140.21,292.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,284.2a13.23,13.23,0,0,0-2.51.22.08.08,0,0,0,0,.15,12.39,12.39,0,0,0,2.51-.11A.13.13,0,0,0,136.07,284.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.61,271.89a87.15,87.15,0,0,1,17.85,8.41,53.33,53.33,0,0,1,14.87,14.12,132.2,132.2,0,0,1,19.06,38.49,102.52,102.52,0,0,1,4.32,23.48.23.23,0,0,1-.45,0,133.21,133.21,0,0,0-11.62-39.87c-5.83-12.35-13.18-25.49-24.42-33.67-6.12-4.45-13-7.37-19.86-10.45C66,272.28,66.25,271.77,66.61,271.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91,324.1A80.28,80.28,0,0,0,99.7,313.77c-7.94-4.41-14.39-7.31-16.36-11.16s4.16-8.85,4.16-8.85-8.1,4-11.46,1.05-10.42-23.35-10.42-23.35S84.33,278.11,96,291.6,113.91,324.1,113.91,324.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,319.89C103.58,302.33,91.09,286.44,74,276h0a86.26,86.26,0,0,1,12.52,9.8,19.88,19.88,0,0,0-10.06,2.12.06.06,0,0,0,0,.11,27.5,27.5,0,0,1,10.35-1.75.25.25,0,0,0,.12,0c.61.57,1.2,1.16,1.8,1.75a31.46,31.46,0,0,0-5.38.71s0,.08,0,.08a27,27,0,0,1,5.67-.47,116.91,116.91,0,0,1,8.83,10,8.84,8.84,0,0,0-3.76.27.07.07,0,1,0,0,.14,19.92,19.92,0,0,1,4-.05c.51.65,1,1.3,1.53,2a35.87,35.87,0,0,0-11.35,1.1c-.06,0,0,.1,0,.09A45.65,45.65,0,0,1,100,301c.48.63.93,1.28,1.4,1.92a24.56,24.56,0,0,0-6.76.78.07.07,0,0,0,0,.13,26.09,26.09,0,0,1,7-.54c2,2.77,3.94,5.61,5.79,8.47a6.36,6.36,0,0,0-3,.18,0,0,0,0,0,0,.08,13.26,13.26,0,0,1,3.21.16q2.5,3.88,4.82,7.85C112.7,320.29,113.06,320.12,112.93,319.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.38,305.32a14.35,14.35,0,0,0-5.44.67s0,.09,0,.08a40.82,40.82,0,0,1,5.41-.56C98.48,305.51,98.51,305.33,98.38,305.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,283.92a9.19,9.19,0,0,0-2.51.14c-.09,0-.06.16,0,.15.83-.09,1.64-.06,2.46-.08A.11.11,0,0,0,82.06,283.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 382.18 95.81 382.18 101.83 338.07 103.37 326.76 130.48 326.76 132.02 338.07 138.04 382.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 338.07 101.83 338.07 103.37 326.76 130.48 326.76 132.02 338.07",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.49,
    y: 322.84,
    width: 34.86,
    height: 9.58,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "68.96 382.18 144.97 381.94 220.98 381.85 373 381.68 525.02 381.85 601.03 381.94 677.04 382.18 601.03 382.43 525.02 382.51 373 382.68 220.98 382.51 144.97 382.42 68.96 382.18",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-93"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 425.29,
    rx: 286.74,
    ry: 31.42,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.25,420.09c-2.33.79-69.14,1-71.7-.58-1-.6-1.57-10.33-2-22.11-.09-2.54-.16-5.17-.22-7.83L229,353.93l44.67-.29,4.21,35.65-.17,7.84s25.62,11.35,28.24,13.41S310.58,419.3,308.25,420.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,420.09c-2.33.79-69.14,1-71.7-.58-1.18-.74-1.82-14.95-2.18-29.94l43.46-.28-.17,7.84s25.62,11.35,28.24,13.41S310.58,419.3,308.25,420.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,420.09c-2.33.79-69.14,1-71.7-.58-1-.6-1.57-10.33-2-22.11l43.07-.27s25.62,11.35,28.24,13.41S310.58,419.3,308.25,420.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,417.42c-11.2-.24-56.4-.13-67.49.49-.09,0-.09.06,0,.07,11.1.47,56.3,0,67.49-.38C307.52,417.59,307.52,417.42,307.28,417.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.59,408.15a9,9,0,0,0-6.69,2.76,8.66,8.66,0,0,0-2.48,6c0,.07.12.07.13,0a10.4,10.4,0,0,1,9-8.6A.07.07,0,0,0,301.59,408.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,398.23c-4.48-.05-9.67,1.55-12.45,5.23-.1.14.1.29.23.22a62.24,62.24,0,0,1,12.3-4.9A.28.28,0,0,0,282,398.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.48,399.56c-4.49,0-9.68,1.56-12.45,5.23-.11.15.09.3.23.23a61.59,61.59,0,0,1,12.29-4.91A.28.28,0,0,0,285.48,399.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,400.9c-4.48,0-9.67,1.55-12.45,5.23-.1.14.1.29.23.22a62.24,62.24,0,0,1,12.3-4.9A.28.28,0,0,0,288.94,400.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.41,402.24c-4.49-.05-9.68,1.55-12.45,5.23-.11.14.1.29.23.22a62,62,0,0,1,12.3-4.9A.28.28,0,0,0,292.41,402.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,407.26c-5,0-5,7.85,0,7.82S247.65,407.23,242.61,407.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,386.25c-2.27-1.88-5.13,0-6.52,1.93a23.58,23.58,0,0,0-4,11.48c0,.09.07.13.14.13a.54.54,0,0,0,.81.35c3.18-2.21,6.86-4.19,9.27-7.32C287.88,391,289,388,286.81,386.25Zm-5.46,9.54c-1.54,1.13-3.13,2.18-4.63,3.37.8-2.24,1.49-4.5,2.51-6.66a25.05,25.05,0,0,1,1.62-3c1-1.49,5.36-5.25,5.82-.38C286.93,391.79,283.18,394.45,281.35,395.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.13,401.36c3.9.58,7.93-.54,11.76-1.15a.55.55,0,0,0,.33-.82.12.12,0,0,0,0-.19,23.5,23.5,0,0,0-10.86-5.47c-2.36-.45-5.7.2-6,3.13C260,399.62,262.85,401,265.13,401.36Zm-2.72-2.54c-3-3.84,2.73-4.17,4.45-3.77a25.58,25.58,0,0,1,3.28,1.06,69.56,69.56,0,0,1,6.41,3.05c-1.9.19-3.77.53-5.66.79C268.63,400.25,264.09,400.93,262.41,398.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,189.2s51.87,88.24,53.26,94.44C218.71,293.16,230,387.17,230,387.17l54-1s-9.3-82.89-18.11-110.2c-6.34-19.67-52.12-84.91-52.12-84.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.09,377.93c-7.75-.06-35.22-.37-45.54.59-.08,0-.07.14,0,.15,3.55.51,37.78-.28,45.53-.53A.11.11,0,1,0,279.09,377.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17,197.3c3.4,5.33,7,10.55,10.46,15.84S189.57,223.72,193,229q10.26,16,20,32.21A98.63,98.63,0,0,1,221.1,277a96.75,96.75,0,0,1,4.55,16.94c1.06,5.79,1.76,11.64,2.41,17.49q1,9.33,2.09,18.67,2.13,19.11,4.27,38.22c.17,1.56.34,3.12.5,4.69,0,.23-.39.27-.42,0-1.59-12.65-2.91-25.35-4.35-38q-1.08-9.47-2.15-18.93c-.67-5.87-1.31-11.75-2.22-17.58a115,115,0,0,0-3.8-17A81.65,81.65,0,0,0,214.52,265c-6.25-10.79-12.87-21.39-19.49-32s-13.42-21.31-20.4-31.79c-.86-1.29-1.73-2.58-2.63-3.85C171.93,197.29,172.11,197.2,172.17,197.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,425.29c-2.46-.15-66-25.89-67.76-28.33a.84.84,0,0,1-.1-.47c0-2.19,4.41-9.83,8.09-19.87.23-.64,1.87-3.62,4.14-7.63C131,358,142,339.07,142,339.07l41.53,16.5-19.88,29.75-3.09,7.2s19.49,20.15,21.13,23S182.77,425.43,180.32,425.29Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,425.29c-2.46-.15-66-25.89-67.76-28.33a.84.84,0,0,1-.1-.47c0-2.19,4.41-9.83,8.09-19.87.23-.64,1.87-3.62,4.14-7.63l39,16.33-3.09,7.2s19.49,20.15,21.13,23S182.77,425.43,180.32,425.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,425.29c-2.46-.15-66-25.89-67.76-28.33-.68-.93,2.16-9.6,8-20.34l40,15.91s19.49,20.13,21.14,23S182.77,425.43,180.32,425.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.42,422.45c-10.29-4.42-52.23-21.28-62.74-24.86-.09,0-.11,0,0,.06,10.11,4.6,52.18,21.12,62.7,25C180.58,422.7,180.64,422.54,180.42,422.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,411.72a9,9,0,0,0-7.24,0,8.7,8.7,0,0,0-4.54,4.62c0,.06.09.11.12.05a10.41,10.41,0,0,1,11.61-4.59A.07.07,0,0,0,178.62,411.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,395.18c-4.13-1.73-9.55-2.19-13.5.18-.15.09,0,.3.13.29a62.34,62.34,0,0,1,13.24.07A.28.28,0,0,0,164.19,395.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,397.72c-4.13-1.73-9.55-2.19-13.5.18-.15.09,0,.3.13.29a61.69,61.69,0,0,1,13.24.07A.28.28,0,0,0,166.9,397.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,400.26c-4.14-1.73-9.56-2.19-13.5.18-.16.09,0,.3.12.29a61.69,61.69,0,0,1,13.24.07A.28.28,0,0,0,169.62,400.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.33,402.8c-4.14-1.73-9.55-2.19-13.5.17-.16.1,0,.31.12.3a61.69,61.69,0,0,1,13.24.07A.28.28,0,0,0,172.33,402.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,388.77c-4.67-1.86-7.57,5.41-2.88,7.27S129,390.63,124.28,388.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,385.88c-1.41-2.59-4.74-1.95-6.77-.66a23.52,23.52,0,0,0-8,9.13.12.12,0,0,0,.08.17c0,.33.22.72.61.64,3.79-.87,7.94-1.32,11.34-3.32C172.35,390.68,174.47,388.33,173.14,385.88Zm-8.65,6.79c-1.85.47-3.71.85-5.54,1.39a69.94,69.94,0,0,1,4.81-5.23,25.34,25.34,0,0,1,2.65-2.2c1.45-1,6.93-2.85,5.53,1.84C171.17,391.06,166.7,392.11,164.49,392.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,391.75c3.4,2,7.55,2.47,11.33,3.35.39.09.65-.3.62-.64a.11.11,0,0,0,.08-.17,23.52,23.52,0,0,0-8-9.15c-2-1.3-5.35-1.95-6.77.63S145.38,390.58,147.37,391.75Zm-1.56-3.38c-1.39-4.69,4.08-2.83,5.53-1.82a24.33,24.33,0,0,1,2.64,2.21,70,70,0,0,1,4.8,5.24c-1.83-.54-3.69-.93-5.54-1.4C151,392,146.57,391,145.81,388.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.88,383.66l-46.49-18.77s57.64-84.75,58.06-91.06c.38-5.58-24.94-54.2-25.93-68.37-1.08-15.3,6.28-27.13,14.38-34.48l47.95,20.39s-5.06,8.09-13,12.6c0,0,24.59,56.2,23.19,73.48S166.88,383.66,166.88,383.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,374.82c-6.72-2.89-4.75-2.16-11.51-5-3.3-1.38-25-10.41-28.34-11.16-.07,0-.12.1-.05.14,2.89,1.77,24.77,10.42,28.1,11.74,6.81,2.68,4.88,1.84,11.72,4.44A.1.1,0,1,0,168.94,374.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,202.94a90.5,90.5,0,0,0-14.6,4.74.15.15,0,1,0,.1.29c4.9-1.43,9.88-2.77,14.7-4.46C210.28,203.38,210.09,202.86,209.71,202.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,201a21.65,21.65,0,0,0-1.23,2.57,5.91,5.91,0,0,0-.63,2.15c0,.15.2.18.29.09a7.51,7.51,0,0,0,1.2-2c.41-.79.83-1.57,1.22-2.38C205.12,200.84,204.31,200.46,204,201Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,196.46c.3-.74.59-1.47.9-2.21s.7-1.5,1-2.28c0-.12.24,0,.19.09-.3.74-.49,1.52-.72,2.28s-.49,1.52-.74,2.28c-.47,1.41-1,2.81-1.65,4.18a5.3,5.3,0,0,0,2.3-.4,4.13,4.13,0,0,0,1.63-2c.42-.82.81-1.66,1.24-2.48a16.57,16.57,0,0,0,1.33-2.79c0-.12.24,0,.19.09a32.45,32.45,0,0,1-2.55,5.91c-.45.73-.8,1.5-1.62,1.78a6.78,6.78,0,0,1-2.73.19c-.12,0-.26,0-.22-.18A47.4,47.4,0,0,1,204.6,196.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.56,205.8c1.71,3.61,3.21,7.21,4.8,10.81s3,7.08,4.43,10.66c2.86,7.22,5.42,14.58,7.67,22,1.11,3.68,2.14,7.39,3.06,11.13a80,80,0,0,1,2.22,11.36,30,30,0,0,1-1,11.4,66.68,66.68,0,0,1-4.23,10.63c-1.05,2.16-1.4,1.87-.9.78,1.43-3.1,5.18-12.49,4.91-20.38A58.82,58.82,0,0,0,221.78,263q-1.31-5.67-2.95-11.25c-2.13-7.34-4.66-14.53-7.26-21.71-1.46-4-3-8-4.5-12s-3-7.68-4.68-12.1C202.34,205.76,202.51,205.69,202.56,205.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.27,193.87c.83-.31,2,.2,2.84.34a24.28,24.28,0,0,0,3.29.33,23.78,23.78,0,0,0,3.27-.11,7,7,0,0,0,3.13-.83,15.93,15.93,0,0,0,4-4.23,24.61,24.61,0,0,0,3.11-5.46c0-.12.21,0,.17.08-.35,1.11-.61,2.23-1,3.32a20.15,20.15,0,0,1-1.54,2.95,12.61,12.61,0,0,1-4.14,4.7c-1.93,1.1-4.41,1-6.56.91a25.63,25.63,0,0,1-3.71-.49c-.88-.19-2.36-.33-2.92-1.1A.27.27,0,0,1,167.27,193.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.66,356q11.46-17.36,22.5-35t21.78-35.55c1.71-2.85,3.68-5.69,4.78-8.85,1.2-3.43.52-6.76-.56-10.12a171.63,171.63,0,0,0-7.14-18c-2.68-5.91-5.57-11.72-8.41-17.55s-5.81-11.59-8-17.67c-2-5.81-2.81-11.83-1.25-17.85s4.92-11.34,8.43-16.35c.92-1.32,1.87-2.63,2.8-4,.07-.1.22,0,.15.12-3.87,5.22-7.64,10.75-9.91,16.88a29.15,29.15,0,0,0-1.92,9.45,30.59,30.59,0,0,0,1.51,9.67c1.88,6.08,4.85,11.83,7.62,17.55s5.73,11.64,8.46,17.53A187.64,187.64,0,0,1,182,264.45c.93,2.75,2,5.63,1.92,8.58-.07,3.23-1.61,6.14-3.21,8.86-7,11.85-14.17,23.56-21.47,35.2s-14.81,23.28-22.41,34.8l-2.88,4.35C133.8,356.42,133.54,356.21,133.66,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.51,137.47c4.33,9.5,26.2,22.59,36.44,24,7.36,1,29.74,1.36,37.41.19,9-1.38,2.12-25.63-3.19-25-14.6,1.7-27,3.6-30.9,3.6-4.76,0-30.51-8.26-33.61-9.43C216.06,128,215.06,132.08,217.51,137.47Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.65,140c5.48,8.11,23.69,21.37,23.69,21.37l2.53-5.6,8.37-18.52S235.51,132,224.5,129.6a24.12,24.12,0,0,0-3.94-.56C213.53,128.66,212.92,133,217.65,140Z",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.65,140c5.48,8.11,23.69,21.37,23.69,21.37l2.53-5.6c-6.79-7.89-17.28-19.84-23.31-26.71C213.53,128.66,212.92,133,217.65,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,157.61c1.39-3.41,7.57-17.14,9.11-20,.1-.2.26-.18.17,0a201.71,201.71,0,0,1-9.14,20C238.16,157.73,238,157.69,238.06,157.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.49,136.91c8.88-1.16,19.87-3.15,29.18.8a5,5,0,0,1,2.49,2.13c4.2,1.7,4.66,4.19,4.66,4.19,3.43,2.78,3.55,5.4,3.55,5.4s4.92,2,4.17,5.22c-.82,3.56-7.56,0-12.46.29-11.25.7-27,4.83-30.25,5.35Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,147.39a72.4,72.4,0,0,1,9.88,0,71.88,71.88,0,0,1,10.6,2.15.09.09,0,0,0,.06-.17,38.29,38.29,0,0,0-20.54-2.08C304.62,147.27,304.62,147.4,304.78,147.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,140.67c3.23,0,8.91.16,18.41,3.47a0,0,0,0,0,0-.06,34.41,34.41,0,0,0-18.43-3.57C303.18,140.53,303.16,140.66,303.38,140.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.69,137c5.49.28,8.92,1.16,14.44,2.82a0,0,0,0,0,0-.06c-6.08-2.54-8.57-2.78-14.47-3C302.47,136.84,302.48,137,302.69,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.58,156.64c-1.43.67-1.08,1.42,1.65,2.05s14.08.82,13.68,4.78-16.41,3.46-20.88,2.06-11.2-5.24-11.2-5.24C290,159.76,297.44,157.75,303.58,156.64Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,152.61c-.07,1.71-.23,3.45-.47,5.18,0-.07,0-.13.07-.19.33-.9.66-1.82,1.06-2.69,0,0,.1,0,.09,0a14.42,14.42,0,0,1-.86,2.78c-.18.43-.35.85-.54,1.27-.12.77-.26,1.53-.41,2.29-.3,1.43-1.65,7.51-2,8.54-.06.21-.32.16-.3-.08.07-1.12,1.2-7.45,1.43-8.89a77.71,77.71,0,0,1,1.79-8.25C229.31,152.52,229.41,152.56,229.4,152.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,198.08c-2.67,1.37-6.11,3.5-21.61.45-1-.2-1.94-.44-2.92-.73-14.53-4.36-32-21.45-32.95-22.66,0,0,23.09-37.43,52.62-49.2,3.65-1.45,9.69,1.35,13,4.84,1.19,1.25,3.78,10.44,2.79,17.88S221.66,196.71,219,198.08Z",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.92,148.32a11.34,11.34,0,0,1-.65,4.66,10.85,10.85,0,0,1,.65-4.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,173.81a10.33,10.33,0,0,1-.08,2.36,9.8,9.8,0,0,1-.57,2.3,9.85,9.85,0,0,1,.08-2.37A10.37,10.37,0,0,1,206.85,173.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.74,154.54a11.35,11.35,0,0,1-.65,4.67,10.93,10.93,0,0,1,.65-4.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,172.51a10.39,10.39,0,0,1-.08,2.37,9.8,9.8,0,0,1-.57,2.3,9.85,9.85,0,0,1,.08-2.37A10.32,10.32,0,0,1,223.51,172.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,151.24a10.33,10.33,0,0,1,2.36.07,9.83,9.83,0,0,1,2.3.58,11.27,11.27,0,0,1-4.66-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,169.65a11.34,11.34,0,0,1,4.66.65,10.85,10.85,0,0,1-4.66-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,189.58a11.27,11.27,0,0,1,4.66.65,10.91,10.91,0,0,1-4.66-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,182.34a11.34,11.34,0,0,1,4.66.65,10.91,10.91,0,0,1-4.66-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.77,130.4a11.34,11.34,0,0,1,4.66.65,11.34,11.34,0,0,1-4.66-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.12,136.78a9.75,9.75,0,0,1-1.72,1.62,10.62,10.62,0,0,1-2,1.22A10.17,10.17,0,0,1,209.1,138,10.54,10.54,0,0,1,211.12,136.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,154.91a10.11,10.11,0,0,1-1.73,1.61,9.43,9.43,0,0,1-2,1.22,10.53,10.53,0,0,1,1.73-1.61A9.68,9.68,0,0,1,180.33,154.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.78,163.09a10.17,10.17,0,0,1-1.73,1.62,9.68,9.68,0,0,1-2,1.22,10.17,10.17,0,0,1,1.73-1.62A10.32,10.32,0,0,1,218.78,163.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88,178.77a10.17,10.17,0,0,1-1.73,1.62,9.86,9.86,0,0,1-2,1.22,10.17,10.17,0,0,1,1.73-1.62A10.32,10.32,0,0,1,193.88,178.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.32,141.67a10.17,10.17,0,0,1-1.73,1.62,10.62,10.62,0,0,1-2,1.22,10.17,10.17,0,0,1,1.73-1.62A9.86,9.86,0,0,1,228.32,141.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,159.84a10.17,10.17,0,0,1-1.62-1.73,9.61,9.61,0,0,1-1.22-2,9.75,9.75,0,0,1,1.62,1.72A10.93,10.93,0,0,1,227.8,159.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,172.36a10.17,10.17,0,0,1-1.62-1.73,10.32,10.32,0,0,1-1.22-2,10.17,10.17,0,0,1,1.62,1.73A9.86,9.86,0,0,1,172.3,172.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.05,187.25a9.75,9.75,0,0,1-1.62-1.72,10.62,10.62,0,0,1-1.22-2,10.17,10.17,0,0,1,1.62,1.73A10.05,10.05,0,0,1,221.05,187.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.62,144.8a10.11,10.11,0,0,1-1.62-1.72,10.93,10.93,0,0,1-1.22-2,9.75,9.75,0,0,1,1.62,1.72A10.93,10.93,0,0,1,196.62,144.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.05,195.73a10.17,10.17,0,0,1-1.62-1.73,10.54,10.54,0,0,1-1.22-2,9.75,9.75,0,0,1,1.62,1.72A10.42,10.42,0,0,1,197.05,195.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,165.69a10.53,10.53,0,0,1-1.61-1.73,9.43,9.43,0,0,1-1.22-2,10.11,10.11,0,0,1,1.61,1.73A9.68,9.68,0,0,1,201.2,165.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.73,140.75c-3.77-.7-7.31-8.49-7.76-13.73,0-.36,1.76-3.21,3.77-6.78,1.22-2.17,2.51-4.62,3.54-6.94.21-.47,1.44,1.12,1.44,1.12l2.68,2,8.85,6.79a40.34,40.34,0,0,0-5.33,8.27,5,5,0,0,0-.32,1,1.22,1.22,0,0,0,0,.17C228.05,134.63,225.36,141.42,221.73,140.75Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,132.53a1.22,1.22,0,0,0,0,.17,9.91,9.91,0,0,1-1.53-.59c-9.69-4.54-5.42-17.52-5.42-17.52l3.8,1.88,8.85,6.79a40.34,40.34,0,0,0-5.33,8.27A5,5,0,0,0,228.6,132.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42,95.58s4.43,2.81,4.45,7.81-2,9.89-2.42,10.07S244.42,95.58,244.42,95.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,98.18c-2.66,5.25-2.52,21.8.8,26.06,4.82,6.18,14.1,8.31,19.71,2.2,5.43-5.92,4.87-27.48,1-31.5C238.32,89,226.38,90.41,222.44,98.18Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,124h0",
    style: {
      fill: "none",
      stroke: "#f5a79e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.56,111.43s-.09.06-.08.1c.06,1.13-.06,2.43-1.07,2.83,0,0,0,.07,0,.06C236.66,114.22,236.8,112.49,236.56,111.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,110.28c-1.82-.1-1.88,3.54-.19,3.63S237.05,110.36,235.53,110.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,111.39s.09,0,.09.1c-.06,1.13.07,2.43,1.09,2.82,0,0,0,.07,0,.06C242.65,114.18,242.5,112.45,242.73,111.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,110.23c1.81-.11,1.9,3.53.22,3.63S242.24,110.32,243.76,110.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.39,107.51a14.64,14.64,0,0,0,1.41-.48,2.4,2.4,0,0,0,1.36-.76.77.77,0,0,0-.11-.93,1.91,1.91,0,0,0-1.92-.23,2.83,2.83,0,0,0-1.64,1.19A.83.83,0,0,0,234.39,107.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,109.12a14.65,14.65,0,0,1-1.44-.4,2.4,2.4,0,0,1-1.39-.69.75.75,0,0,1,.06-.93,1.89,1.89,0,0,1,1.9-.33,2.8,2.8,0,0,1,1.7,1.1A.82.82,0,0,1,245,109.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,122.12c.27.27.53.63.94.67a3,3,0,0,0,1.22-.26s.07,0,0,.06a1.51,1.51,0,0,1-1.44.59,1.21,1.21,0,0,1-.88-1A.06.06,0,0,1,234,122.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,117.3s.05,1.68,0,2.47a16.48,16.48,0,0,0-4.61.16c-.36.08-.32-.21.09-.4a6.76,6.76,0,0,1,3.92-.52c.08-.21-.13-2.6,0-2.59a6.68,6.68,0,0,1,1.74.6c0-3.52-.56-7-.51-10.52,0-.12.19-.14.21,0a56.64,56.64,0,0,1,1,11.3C242.39,118.23,240.84,117.46,240.54,117.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.29,119.17a5,5,0,0,1-2.1,2.51c-1.51.61-2-.76-.48-2A4.88,4.88,0,0,1,238.29,119.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,121.37a2,2,0,0,1-.53.31c-1.39.56-1.94-.55-.82-1.67C236.13,120.07,237,120.35,236.72,121.37Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.68,112.33c1.83.56,3.93-4.94,4.53-7,.52-1.86,1.12-7.77,1.21-8.18s8,5.23,12.58,3.89,7.69-5.49,7.76-7.42-5.66-6.83-10.61-7.08-11.66,6-11.66,6a23,23,0,0,0,2.2-2.94c-.08-.22-3.28,1.06-3.87,3.34,0,0,.64-2.87.4-2.92s-2.73,2.4-2.17,4.26c0,0-2.88,2.49-3.14,5.22S219.53,111.67,221.68,112.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.28,100a15.21,15.21,0,0,1-4.35,1.56,10.33,10.33,0,0,1-5-.8,15.36,15.36,0,0,1-4.36-2.58c-1.15-.94-2.18-2.09-3.41-2.93-.31-.22-.66.23-.47.51a16.52,16.52,0,0,0,8.36,6.16,9.53,9.53,0,0,0,9.22-1.88S243.3,100,243.28,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,111.84s-2.84-5.76-5.4-4.83-1,8.9,1.63,10.36a2.85,2.85,0,0,0,4-.94Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7,109.28s-.06,0,0,.08c1.82,1.08,2.56,3,3,5a1.57,1.57,0,0,0-2.26-.78c-.06,0,0,.11,0,.11a1.75,1.75,0,0,1,1.81.9,8.45,8.45,0,0,1,.68,1.68c.06.19.39.14.36-.07v0C222.72,113.71,221.32,109.94,218.7,109.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,137.56c-2,11.33,10.28,49.5,18.15,56.63,11.71,10.6,33.36,17.57,41.21,19.84,3.42,1,12.88-23.07,9.42-24.66C266.21,186,243.19,178.8,241,177s-15.39-20.87-21.27-31.85C211.86,130.37,205.83,131.83,204.84,137.56Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.79,187.25s10.22,2.61,16.81,4.62c3.68,1.13,9.82,3.62,12.15,5.68,3.48,3.09,16.06,18.21,12.46,21.34-3.26,2.84-12.42-11.53-12.42-11.53s10.52,13.68,6,16.37S290,208.81,290,208.81s10.49,14.3,5.36,16.33c-3.88,1.53-12.2-14-12.2-14s8.94,12.35,5,14.1c-4.34,1.94-12.91-11.92-12.91-11.92-10.72,2.77-17-.3-21.13-3C253.15,209.66,267.79,187.25,267.79,187.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,202.39c1.3,1.56,2.62,3.14,3.77,4.81s2.24,3.39,3.23,5.16a34.62,34.62,0,0,1,3.2,7.26c-1.72-4.4-5.75-10.45-6.9-12.12s-2.22-3.4-3.36-5.07C293.36,202.39,293.42,202.35,293.45,202.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.34,206.44c2.22,1.76,6.87,8.3,8.66,12.69.08.18,0,.17-.13,0-1.4-2.17-7.08-10.57-8.58-12.66C287.26,206.44,287.31,206.41,287.34,206.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47,209a31.33,31.33,0,0,1,6.42,10c.07.18-.07.15-.18,0-2.07-3.37-3.67-6-6.35-9.91C281.32,209,281.41,208.91,281.47,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,138.39c-9.13-12.91-14.59-8.13-12.76,5.89,1.72,13.11,6.31,28.73,6.31,28.73l23-11.16S221.81,146.66,216,138.39Z",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,143.47a10.28,10.28,0,0,1,.65,2.27,10.39,10.39,0,0,1,.15,2.37,10.34,10.34,0,0,1-.64-2.28A9.77,9.77,0,0,1,221.55,143.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,151.32a11,11,0,0,1,4.63-.8,10.26,10.26,0,0,1-2.27.64A9.8,9.8,0,0,1,207.92,151.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,131.24a11.16,11.16,0,0,1-2.71,3.85,11.16,11.16,0,0,1,2.71-3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,157.35a10.44,10.44,0,0,1-1.15,2.07,10.11,10.11,0,0,1-1.56,1.78,11.16,11.16,0,0,1,2.71-3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,165.18a10,10,0,0,1-2.07-1.15,10.06,10.06,0,0,1-1.78-1.56,11.16,11.16,0,0,1,3.85,2.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,142.28c1.23,1.69,2.5,3.34,3.76,5q-.48-1.26-.84-2.55a0,0,0,1,1,.06,0c.25.66.54,1.31.78,2l.36,1a1.8,1.8,0,0,1,.08.21c1,1.29,2,2.58,2.92,3.9,1.13,1.58,2.22,3.18,3.32,4.78s2.21,3.59,3.4,5.2c.11.14-2,1-2.23,1.11s-.35-.08-.13-.15,1.9-1.1,1.92-1.12c-1.1-1.62-2.37-3.11-3.52-4.68s-2.29-3.14-3.4-4.73c-2.25-3.24-4.31-6.6-6.55-9.85A0,0,0,0,1,219,142.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,153.56c.35.68.73,1.35,1,2.05l.38.87c-.53-2.49-1-5-1.55-7.49,0,0,0,0,0,0,1.06,4,2.13,8.09,3.11,12.15.93,3.88,2.06,7.8,2.6,11.76a13.05,13.05,0,0,1,2.16-.73,10.66,10.66,0,0,1-2.38,1.15,124.82,124.82,0,0,1-3-12.24c-.25-1.12-.48-2.24-.72-3.36-.26-.68-.57-1.33-.88-2s-.59-1.42-.87-2.13C203.69,153.55,203.76,153.51,203.78,153.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,169.15c3.2-1.8,16.57-8.72,19.56-10,.21-.09.32,0,.11.14a201.57,201.57,0,0,1-19.6,10C209.88,169.31,209.8,169.2,209.89,169.15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "576.32 432.05 271.64 432.05 315.69 182.2 620.37 182.2 576.32 432.05",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.97 156.32 320.26 156.32 315.69 182.2 422.4 182.2 419.97 156.32",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "576.32 432.05 271.64 432.05 315.69 182.2 620.37 182.2 576.32 432.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.97 156.32 320.26 156.32 315.69 182.2 422.4 182.2 419.97 156.32"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,166.88a19.17,19.17,0,0,1,0-8.7,19.17,19.17,0,0,1,0,8.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.64,169.44a17,17,0,0,1-2.61-3.52,17.35,17.35,0,0,1-1.75-4,16.58,16.58,0,0,1,2.61,3.51A17.61,17.61,0,0,1,300.64,169.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,176.09a19.18,19.18,0,0,1-7.53-4.35,17.16,17.16,0,0,1,4,1.74A17.58,17.58,0,0,1,294.24,176.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,185.05a19.17,19.17,0,0,1-8.7,0,19.17,19.17,0,0,1,8.7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6,193.91a17.64,17.64,0,0,1-3.52,2.61,17.16,17.16,0,0,1-4,1.74,17,17,0,0,1,3.52-2.61A16.8,16.8,0,0,1,294.6,193.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,200.3a19.13,19.13,0,0,1-4.35,7.54,16.83,16.83,0,0,1,1.75-4A17.31,17.31,0,0,1,301.24,200.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2,202.51a17.45,17.45,0,0,1,.5,4.35,17,17,0,0,1-.5,4.35,16.57,16.57,0,0,1-.5-4.35A17.45,17.45,0,0,1,310.2,202.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,200a17,17,0,0,1,2.61,3.52,16.8,16.8,0,0,1,1.74,4,19.13,19.13,0,0,1-4.35-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.45,193.3a16.8,16.8,0,0,1,4,1.74,17,17,0,0,1,3.52,2.61,16.8,16.8,0,0,1-4-1.74A17,17,0,0,1,325.45,193.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66,184.34a19.22,19.22,0,0,1,8.71,0,19.22,19.22,0,0,1-8.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,175.48a17.31,17.31,0,0,1,3.52-2.6,16.44,16.44,0,0,1,4-1.75,19.13,19.13,0,0,1-7.54,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,169.09a17.58,17.58,0,0,1,1.74-4,17,17,0,0,1,2.61-3.52,16.8,16.8,0,0,1-1.74,4A17,17,0,0,1,318.45,169.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "575.87 432.05 270.54 432.05 227.18 191.27 532.52 191.27 575.87 432.05",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.99,
    cy: 325.77,
    r: 12.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.31,
    cy: 325.77,
    r: 12.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38,340.49l-.7-1.33c-.06-.12-6.62-12.24-19.81-12.24-12,0-15,11.41-15.08,11.9l-.36,1.45-2.91-.7.35-1.46c0-.14,3.58-14.19,18-14.19,15,0,22.17,13.28,22.47,13.85l.7,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fly--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.71,324.8l-.21-1c.65-.14,1.29-.29,1.93-.46l.25,1C557,324.51,556.37,324.66,555.71,324.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.55,323.19l-.32-.94c1.25-.43,2.5-.9,3.71-1.41l.39.92C564.1,322.28,562.83,322.76,561.55,323.19ZM569,320l-.45-.88c1.17-.61,2.34-1.27,3.45-2l.52.85C571.38,318.76,570.19,319.43,569,320Zm6.88-4.23-.59-.81c1.08-.79,2.12-1.62,3.1-2.47l.66.75C578,314.15,577,315,575.87,315.81Zm6.1-5.32-.73-.69c.92-1,1.79-2,2.59-3l.79.61C583.8,308.47,582.91,309.5,582,310.49Zm4.95-6.4-.85-.53a29.08,29.08,0,0,0,1.84-3.48l.92.41A33.74,33.74,0,0,1,586.92,304.09Zm3.31-7.42-1-.28a26.14,26.14,0,0,0,.81-3.83l1,.13A25.66,25.66,0,0,1,590.23,296.67Zm1.11-8h-1v-.29c0-1.21-.07-2.44-.19-3.65l1-.1a36.24,36.24,0,0,1,.2,3.75Zm-1.8-7.83a39.3,39.3,0,0,0-1-3.82l1-.3c.41,1.3.76,2.62,1,3.91Zm-2.37-7.53c-.48-1.18-1-2.39-1.64-3.61l.9-.45c.61,1.24,1.17,2.48,1.66,3.68Zm-3.5-7.13c-.62-1.09-1.3-2.24-2-3.42l.85-.53c.73,1.19,1.42,2.35,2,3.46Zm-4.18-6.79c-.73-1.1-1.47-2.21-2.23-3.32l.83-.56c.76,1.11,1.5,2.22,2.23,3.34ZM575,252.73c-.75-1.1-1.51-2.21-2.25-3.31l.83-.56c.74,1.1,1.49,2.21,2.24,3.3Zm-4.47-6.66c-.73-1.12-1.44-2.26-2.14-3.4l.85-.52c.7,1.14,1.41,2.26,2.13,3.38Zm-4.17-6.87c-.68-1.21-1.31-2.41-1.88-3.56l.9-.45c.56,1.14,1.19,2.32,1.85,3.52ZM562.81,232c-.53-1.25-1-2.52-1.44-3.76l1-.32c.42,1.21.89,2.46,1.41,3.69Zm-2.6-7.63c-.33-1.3-.62-2.63-.84-4l1-.16c.22,1.28.49,2.58.82,3.86Zm-1.34-8c-.1-1.23-.15-2.47-.15-3.71v-.33h1v.32c0,1.21,0,2.43.15,3.63Zm1-8-1-.1c0-.27.05-.55.08-.84.12-1.07.27-2.14.45-3.16l1,.17c-.17,1-.32,2.05-.44,3.1C560,207.85,560,208.12,559.92,208.4Zm1.39-7.78-1-.27c.37-1.32.8-2.61,1.28-3.84l.93.36A36.6,36.6,0,0,0,561.31,200.62Zm49.83-5.83c-.56,0-1.14-.08-1.71-.16-.78-.11-1.56-.24-2.33-.39l.2-1c.74.14,1.51.27,2.27.38.54.07,1.09.12,1.62.15Zm4.11-.31-.21-1a11.54,11.54,0,0,0,3.56-1.38l.52.85A12.45,12.45,0,0,1,615.25,194.48Zm-51.06-1.19-.89-.47a35.46,35.46,0,0,1,2.11-3.46l.82.57A32.66,32.66,0,0,0,564.19,193.29Zm39-.06a38.51,38.51,0,0,1-3.8-1.43l.41-.92a34.09,34.09,0,0,0,3.69,1.39Zm19-3.12-.83-.56a7,7,0,0,0,1.22-3.49l1,.07A8,8,0,0,1,622.17,190.11Zm-26.4-.15a36.69,36.69,0,0,1-3.39-2.23l.59-.8a35.28,35.28,0,0,0,3.3,2.16Zm-27.1-3.12-.74-.67a33.81,33.81,0,0,1,2.89-2.85l.66.75A33.41,33.41,0,0,0,568.67,186.84Zm20.59-1.69a37,37,0,0,1-2.83-2.91l.75-.66a36.84,36.84,0,0,0,2.75,2.83Zm32.55-2.71a9.77,9.77,0,0,0-2.33-3l.66-.75a10.8,10.8,0,0,1,2.57,3.29Zm-47.22-.79-.57-.82a38.58,38.58,0,0,1,3.47-2.11l.47.88A37.77,37.77,0,0,0,574.59,181.65Zm9.34-2.6c-.38-.54-.75-1.09-1.1-1.66l-1.3.51-.38-.92,1.15-.46c-.18-.3-.36-.6-.53-.9l.87-.49c.2.35.4.7.61,1q.84-.3,1.71-.57l.29,1c-.49.15-1,.31-1.46.48.31.49.63,1,1,1.43Zm32.33-1.72a21.3,21.3,0,0,0-3-1.22l-.66-.21.29-1,.68.22a21.6,21.6,0,0,1,3.12,1.27Zm-27.18-1.79-.21-1c1.29-.29,2.63-.53,4-.72l.15,1C591.67,175,590.36,175.25,589.08,175.54Zm19.7-.54c-1.25-.22-2.57-.39-3.92-.51l.08-1c1.39.12,2.74.29,4,.52Zm-11.85-.58-.07-1c1.19-.07,2.38-.11,3.56-.11h.49v1h-.48C599.27,174.31,598.09,174.34,596.93,174.42ZM580,172c-.54-1.22-1-2.49-1.45-3.78l1-.31c.42,1.26.89,2.5,1.41,3.69Zm-2.53-7.68c-.3-1.29-.55-2.63-.74-4l1-.14c.19,1.32.43,2.63.72,3.9Zm-1.12-8c-.05-.9-.08-1.82-.08-2.74,0-.43,0-.87,0-1.3l1,0c0,.43,0,.85,0,1.28,0,.9,0,1.81.07,2.68Zm1.19-8-1-.1c.14-1.32.33-2.67.56-4l1,.17C577.83,145.72,577.64,147,577.51,148.34Zm1.37-7.81-1-.24c.32-1.29.69-2.59,1.1-3.89l1,.31C579.56,138,579.19,139.27,578.88,140.53Zm2.4-7.57-.93-.36c.49-1.25,1-2.5,1.61-3.71l.9.44C582.29,130.51,581.76,131.73,581.28,133Zm3.44-7.13-.87-.51c.68-1.15,1.41-2.3,2.17-3.4l.82.57C586.09,123.57,585.38,124.69,584.72,125.83Zm4.51-6.51-.78-.63c.84-1,1.74-2.06,2.67-3l.72.69C590.93,117.3,590.05,118.3,589.23,119.32Zm5.44-5.76-.67-.74c1-.89,2-1.77,3.07-2.62l.62.79C596.65,111.82,595.63,112.69,594.67,113.56Zm6.21-4.94-.57-.83c1.09-.75,2.23-1.49,3.39-2.19l.51.85C603.08,107.14,602,107.87,600.88,108.62Zm6.79-4.13-.47-.88c1.18-.63,2.4-1.23,3.62-1.79l.42.91C610,103.28,608.83,103.88,607.67,104.49Zm7.23-3.32-.37-.94c1.26-.49,2.53-1,3.79-1.37l.32,1C617.4,100.22,616.14,100.68,614.9,101.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.64,98.62l-.25-1c1.24-.32,2-.46,2-.46l.18,1S623.85,98.31,622.64,98.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.32,92.16c-2.55-7.9-19.63-5.06-16.3,5.27S642.87,100.07,640.32,92.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.73,89c.13-3.47,4.95-6.14,11.77-4.91s13.23,5.83,13.23,5.83S633,94,626.11,94.75,614.6,92.46,614.73,89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.73,89.9c-3.54,0-7.07-.1-10.6-.21s-7.07-.29-10.6-.57c3.54,0,7.08.09,10.61.2S636.21,89.61,639.73,89.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.58,85.91a29.75,29.75,0,0,1,5.65,3.53,26.64,26.64,0,0,1-2.92-1.6A28.63,28.63,0,0,1,621.58,85.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.85,89.57A32.47,32.47,0,0,1,625,93.35a32.47,32.47,0,0,1,5.88-3.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.88,87.62a7.24,7.24,0,0,1,2.58,2.08,6.85,6.85,0,0,1-1.41-.89A7.32,7.32,0,0,1,631.88,87.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.23,109.55c2.13,2.74,7.6,2.08,12.41-2.9S641,94.18,641,94.18s-7.88.6-13.89,4S619.09,106.8,621.23,109.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,94.18c-2.88,2-5.68,4.22-8.49,6.37s-5.56,4.37-8.25,6.66c2.88-2,5.68-4.21,8.48-6.36S638.27,96.48,641,94.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.58,108a28.53,28.53,0,0,0,1.43-3,26.73,26.73,0,0,0,1.08-3.16,27.77,27.77,0,0,0-1.43,3A28.52,28.52,0,0,0,628.58,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,99.64a33.06,33.06,0,0,0-7,.37,29.2,29.2,0,0,0,3.5,0A31.11,31.11,0,0,0,634,99.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.93,100.63a7.15,7.15,0,0,0,.62-1.56,7.48,7.48,0,0,0,.26-1.65,7.45,7.45,0,0,0-.88,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.32,92.16a3,3,0,1,1,1.93-3.77A3,3,0,0,1,640.32,92.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.16,97.87a3,3,0,1,1,1.93-3.78A3,3,0,0,1,642.16,97.87Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.31,95.32a24.92,24.92,0,0,1-41.64,15.77l-12.47,1.83,6.24-10.78a24.92,24.92,0,1,1,47.87-6.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.31,95.32a25,25,0,0,1-5,12.63,22.11,22.11,0,0,1-4.89,4.83,24.26,24.26,0,0,1-6,3.35,24.53,24.53,0,0,1-6.71,1.6,25,25,0,0,1-3.46.07,22.18,22.18,0,0,1-3.45-.36,25.16,25.16,0,0,1-12.33-6.09l.29.09-12.45,1.91-.91.14.46-.8,6.2-10.8,0,.43a25.18,25.18,0,0,1,1.54-22.21,25.54,25.54,0,0,1,7.8-8.32,25.37,25.37,0,0,1,21.91-3,25.53,25.53,0,0,1,9.61,5.9A25,25,0,0,1,314.31,95.32Zm0,0a24.65,24.65,0,0,0-28.26-27,24.38,24.38,0,0,0-10.29,4.06,25.69,25.69,0,0,0-7.46,8.14,24.62,24.62,0,0,0-3.17,10.54A24.87,24.87,0,0,0,266.89,102l.09.22-.12.21-6.28,10.76-.44-.66,12.48-1.75.17,0,.12.11A24.56,24.56,0,0,0,284.85,117a21.23,21.23,0,0,0,3.38.41,24.26,24.26,0,0,0,3.41,0,25,25,0,0,0,6.66-1.47,23.44,23.44,0,0,0,6-3.24,22.78,22.78,0,0,0,4.9-4.77A25,25,0,0,0,314.31,95.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.34,104.35a2.42,2.42,0,0,1,2.44-2.56,2.56,2.56,0,0,1,0,5.12A2.42,2.42,0,0,1,277.34,104.35Zm1-5.91-.58-19.84h4l-.58,19.84Z",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,104.35a2.42,2.42,0,0,1,2.43-2.56,2.56,2.56,0,0,1,0,5.12A2.42,2.42,0,0,1,286.85,104.35Zm1-5.91L287.3,78.6h4l-.58,19.84Z",
    style: {
      fill: "#4ADE80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,104.35a2.42,2.42,0,0,1,2.44-2.56,2.56,2.56,0,0,1,0,5.12A2.42,2.42,0,0,1,296.35,104.35Zm1-5.91-.58-19.84h4l-.57,19.84Z",
    style: {
      fill: "#4ADE80"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoappointment);
export default __webpack_public_path__ + "static/media/noappointment.5c7b570a8491bd7332fe74c6bae9dd1d.svg";
export { ForwardRef as ReactComponent };